import { TemplateQuestionsTable } from './TemplateQuestionsTable';

export default TemplateQuestionsTable;